import i18n from '@/language'
import Swal from 'sweetalert2'
import { sanitizeHtml } from "@/directive/safeHtml";

import {
    getFactory
} from "@/api/module/factory"

import {
    useIntent
} from "@/hook/useIntent";

import {
    usePermission
} from "@/hook/usePermission";

import $ from "jquery"

import {
    useUser
} from "@/hook/useUser";

import { reactive
} from "vue";

import {
    renderComponent
} from "@/hook/useComponent";

import QrcodeLogin from "@/component/qrocde/Login.vue";
import MindCatcherShare from "@/component/mindcatcher/Share.vue";

//尚未綁定App提示 - 圖示 (以原始碼嵌入swal的html, 顏色靠currentColor跟著主題走)
import scanIcon from "@/asset/iconsax/scan.svg?raw";
import checkIcon from "@/asset/iconsax/check.svg?raw";
import {getMindcatcher} from "@/api/module/mindcatcher";
import {EnumMaintenance} from "@/enum/maintenance";

//尚未綁定App提示 - 「不再顯示此提示」勾選框的id
const MAPPING_CHECK_ID = "mappingNoticeCheck"

/**
 * SweetAlert2 封裝
 */
export const useSwalAlert = () => {

    //導入i18n
    const {
        // @ts-ignore
        t
    } = i18n.global

    /**
     * 顯示成功
     */
    const showSuccess = (configure) => build(configure, "success")

    /**
     * 顯示下載成功
     */
    const showDownloadSuccess = () => build({
        subject: t(`component.message.download.subject`),
        text: t(`component.message.download.text`)
    }, "success")

    /**
     * 顯示失敗
     */
    const showWarning = (configure) => build(configure, "warningOne")

    /**
     * 顯示提問
     */
    const showHandler = (configure) => build(configure)

    /**
     * 顯示 status !== 200 的錯誤
     */
    const showErrorStatus = async (status) => {

        const {
            reloadIntent,
            homePage404Intent,
            replaceIntent
        } = useIntent()

        const {
            setLogin
        } = usePermission()

        /**
         * 參數 - Swal - 控制
         */
        const configure = {
            subject: t(`error.${status}.subject`),
            text: t(`error.${status}.text`)
        }

        //無登入權杖
        if (status === 401) {

            //清除登入旗標（cookie 由後端在 401 時清掉）
            setLogin(false)

            configure.completion = {
                failure: () => {
                    replaceIntent(`Login`)
                }
            }

            build(configure, "warningOne")

        }
        //找不到頁面, 回到首頁
        else if (status === 404) {

            configure.completion = {
                failure: () => {
                    homePage404Intent()
                }
            }

            build(configure, "warningOne")

        }
        //權限不足：重新整理只會得到同樣結果，只提示、留在原頁
        else if (status === 403) build(configure, "warningOne")
        //心靈捕手錯誤
        else if (status === 904) build(configure, "warningOne")
        //二級認證失敗
        else if (status === 998) build(configure, "warningOne")
        //找不到頁面, 回到首頁
        else {

            configure.confirmButtonText = `submit.relocation`
            configure.completion = {
                success: () => {
                    reloadIntent()
                }
            }

            build(configure)

        }

    }

    /**
     * 顯示二次驗證
     */
    const showTwoFactory = (
        configure,
        appContext
    ) => {

        let destroyComp

        /**
         * 參數 - 本地
         */
        const active = reactive({
            passwd: "",
            is: {
                qrcode: true
            }
        })

        const {
            getUser
        } = useUser()

        Swal.fire({
            //標題
            title: sanitizeHtml(configure.subject),
            //副標題
            html: sanitizeHtml(configure.text),
            //顯示右上角關閉按鈕
            showCloseButton: false,
            //點外側關閉
            allowOutsideClick: false,
            //顯示取消按鈕
            showCancelButton: true,
            //強迫確認
            focusConfirm: false,
            //確認按鈕文字
            confirmButtonText: t(`submit.accept`),
            //取消按鈕的預設文字
            cancelButtonText: t('submit.cancel'),
            //輸入框的類型
            input: 'password',
            //自定義外觀
            customClass: {
                container: "two-factory",
                input: 'form-control form-control-lg',
            },
            //即將開啟
            willOpen() {

                //創建
                destroyComp = renderComponent(
                    $(`#swal2-html-container`)[0],
                    QrcodeLogin,
                    //接收$emit, 前面帶個on, close => onClose
                    {
                        //傳入前置參數
                        data: {
                            organization: {
                                uuid: getUser.value.church.organization,
                                name: null
                            },
                            available: true,
                            uuid: getUser.value.church.uuid,
                            name: getUser.value.church.name,
                            avatarUrl: null
                        },
                        //指定嵌入sweet alert
                        isSwal: true,
                        //指定取消時順便關閉swal
                        isCancelClose: true,
                        //頂部加塞
                        marginTop: 2,
                        //底部加塞
                        marginBottom: 0,
                        //密碼輸入時的占位符
                        placeholder: configure.description,
                        //監聽 - 切換輸入模式
                        onChangeMode: (e) => {

                            active.is.qrcode = e

                            active.passwd = ""

                            const d = $(".swal2-container.two-factory .swal2-confirm")
                            d.prop("disabled", true).addClass(`cursor-not-allowed`)

                            //如果切換到qrcode模式, 隱藏確定
                            if (active.is.qrcode) d.hide()
                            //如果切換到passwd模式, 顯示確定
                            else d.show()

                        },
                        //監聽 - 輸入密碼
                        onKeyup: (e) => {

                            //紀錄輸入的密碼
                            active.passwd = e

                            const disabled = active.passwd.length === 0

                            const d = $(".swal2-container.two-factory .swal2-confirm")
                            d.prop("disabled", disabled)

                            if (disabled) d.addClass(`cursor-not-allowed`)
                            else d.removeClass(`cursor-not-allowed`)

                        },
                        //監聽 - 授權成功
                        onAuthorize: () => setTimeout(()=>{
                            if (configure.completion?.success) configure.completion.success()
                        }, 0),
                        //監聽 - 密碼模式下, 按entry送出
                        onSubmit: (e) => {
                            //有輸入字元才送出
                            if (e.length > 0) $(".swal2-container.two-factory .swal2-confirm").trigger('click')
                        },
                        //監聽 - 手機按取消
                        onCancel: () => setTimeout(()=>Swal.close(), 0)
                    },
                    appContext
                )

            },
            //關閉完成
            didClose() {
                //銷毀
                destroyComp?.()
            },
            //開啟完成
            didOpen(e) {

                //隱藏原始的輸入框, 不能移除, 否則 preConfirm 會報錯
                $(".swal2-input",$(e)).hide()

                const d = $(".swal2-container.two-factory .swal2-confirm")
                //先停用確認送出
                d.prop("disabled", true).addClass(`cursor-not-allowed`)
                //隱藏確認送出
                d.hide()

            },
            //提交前檢查
            preConfirm: () => {

                //正確返回輸入值, then中的result.value就會繼承值
                //返回false, then就不會執行
                if (active.is.qrcode) return true
                return active.passwd.length > 0

            }
        }).then(async (result) => {

            //密碼驗證才會跑到這邊來

            //按取消不往下執行
            if (!result.isConfirmed) return false

            //進行二級認證 (密碼方式才走這邊)
            const {
                data
            } = await getFactory({passwd: active.passwd})

            //認證失敗 - 不正確返回
            if (data?.result === undefined) {
                await showErrorStatus(998)
                return false
            }
            else if (!data?.result) {
                await showErrorStatus(998)
                return false
            }

            //執行回調
            setTimeout(()=>{
                if (configure.completion?.success) configure.completion.success()
            }, 0)

        })

    }

    /**
     * 顯示心靈捕手
     */
    const showMindCatcher = (
        configure,
        appContext
    ) => {

        let destroyComp

        /**
         * 參數 - 本地
         */
        const active = reactive({
            length: 16,
            key: ""
        })

        Swal.fire({
            //圖
            imageUrl: new URL(
                `/src/asset/img/core/mc-logo.png`,
                import.meta.url
            ).href,
            //圖 - 寬
            imageWidth: 80,
            //圖 - 高
            imageHeight: 80,
            //標題
            title: sanitizeHtml(configure.subject),
            //副標題
            html: sanitizeHtml(configure.text),
            //顯示右上角關閉按鈕
            showCloseButton: false,
            //點外側關閉
            allowOutsideClick: false,
            //顯示取消按鈕
            showCancelButton: true,
            //強迫確認
            focusConfirm: false,
            //確認按鈕文字
            confirmButtonText: t(`submit.accept`),
            //取消按鈕的預設文字
            cancelButtonText: t('submit.cancel'),
            //輸入框的類型
            input: 'password',
            //自定義外觀
            customClass: {
                container: "two-factory mindcatcher",
                input: 'form-control form-control-lg',
            },
            //即將開啟
            willOpen() {

                //創建
                destroyComp = renderComponent(
                    $(`#swal2-html-container`)[0],
                    MindCatcherShare,
                    //接收$emit, 前面帶個on, close => onClose
                    {
                        //input的最長長度
                        maxLength: active.length,
                        //頂部加塞
                        marginTop: 2,
                        //底部加塞
                        marginBottom: 0,
                        //密碼輸入時的占位符
                        placeholder: configure.description,
                        //監聽 - 輸入密碼
                        onKeyup: (e) => {

                            //紀錄輸入的密碼
                            active.key = e

                            const disabled = active.key.length !== active.length

                            const d = $(".swal2-container.two-factory .swal2-confirm")
                            d.prop("disabled", disabled)

                            if (disabled) d.addClass(`cursor-not-allowed`)
                            else d.removeClass(`cursor-not-allowed`)

                        },
                        //監聽 - 密碼模式下, 按entry送出
                        onSubmit: (e) => {
                            //有輸入字元才送出
                            if (e.length !== active.length) return false
                            $(".swal2-container.two-factory .swal2-confirm").trigger('click')
                        }
                    },
                    appContext
                )

            },
            //關閉完成
            didClose() {
                //銷毀
                destroyComp?.()
            },
            //開啟完成
            didOpen(e) {

                //隱藏原始的輸入框, 不能移除, 否則 preConfirm 會報錯
                $(".swal2-input",$(e)).hide()

                const d = $(".swal2-container.two-factory .swal2-confirm")
                //先停用確認送出
                d.prop("disabled", true).addClass(`cursor-not-allowed`)

            },
            //提交前檢查
            preConfirm: () => {

                return active.key.length === active.length

            }
        }).then(async (result) => {

            //密碼驗證才會跑到這邊來

            //按取消不往下執行
            if (!result.isConfirmed) return false

            //開始前
            if (configure.completion?.before) configure.completion.before()

            //進行二級認證 (密碼方式才走這邊)
            const {
                data
            } = await getMindcatcher({key: active.key})

            //認證失敗 - 不正確返回
            if (data?.result === undefined) {
                await showErrorStatus(904)
                return false
            }
            else if (!data?.result) {
                await showErrorStatus(904)
                return false
            }

            //執行回調
            setTimeout(()=>{
                if (configure.completion?.success) configure.completion.success(active.key)
            }, 0)

        })

    }

    /**
     * 維護中
     * @param e
     * @param r
     */
    const showMaintenance = (
        e,
        r
    ) => build({
        subject: t(`maintenance.${e}.subject`),
        text: t(`maintenance.${e}.text`),
        completion: {
            //完成顯示錯誤
            done: async () => await r.push({
                name: [
                    EnumMaintenance.SHEPHERD
                ].includes(e) ? `ShepherdDashboard` : `AdminDashboard`
            })
        }
    }, "warningOne")

    /**
     * 尚未綁定App - 提示
     *
     * 不強迫跳轉綁定頁, 僅提示引導,
     * 按確定才前往綁定頁, 按取消就留在原地 (不影響一般帳密登入流程)。
     * 內含「不再顯示此提示」勾選框, 不論按確定或取消都會回拋勾選結果。
     *
     * @param r router實例
     * @param id 網址列上的教會no
     * @param onDisable 勾選「不再顯示此提示」的回調 (由 useMappingNotice 寫入cookie)
     */
    const showMapping = (
        r,
        id,
        onDisable
    ) => {

        //是否勾選不再顯示 (按取消也要生效, 故用didOpen掛監聽紀錄, 不從result取值)
        let disabled = false

        Swal.fire({
            //圖示 - 沿用question的柔和主題色底, 內容換成掃碼圖示
            icon: "question",
            // html-sink-ok: 打包進來的 svg 原始碼
            iconHtml: scanIcon,
            //標題
            title: t(`尚未完成App綁定`),
            //內容 - 說明 + 好處 + 不再顯示
            // html-sink-ok: 只有字面值 key 的 t()、打包的 svg 與常數 id
            html: `
                <p class="mn-lead">${t(`綁定後開啟App掃碼就能登入更快也更安全`)}</p>
                <ul class="mn-list">
                    <li>${checkIcon}<span>${t(`免輸入帳號密碼掃碼即可登入`)}</span></li>
                    <li>${checkIcon}<span>${t(`未綁定不影響現有的帳號密碼登入`)}</span></li>
                    <li>${checkIcon}<span>${t(`隨時可從右上角頭像選單的個人資料完成綁定`)}</span></li>
                </ul>
                <label class="mn-check" for="${MAPPING_CHECK_ID}">
                    <input id="${MAPPING_CHECK_ID}" type="checkbox">
                    <span class="mn-box">${checkIcon}</span>
                    <span class="mn-text">${t(`不再顯示此提示`)}</span>
                </label>
            `,
            //顯示右上角關閉按鈕
            showCloseButton: false,
            //點外側關閉
            allowOutsideClick: false,
            //顯示取消按鈕
            showCancelButton: true,
            //強迫確認
            focusConfirm: false,
            //確認按鈕文字
            confirmButtonText: t(`前往綁定`),
            //取消按鈕文字
            cancelButtonText: t(`稍後再說`),
            //自定義外觀
            customClass: {
                container: "mapping-notice"
            },
            //開啟完成
            didOpen: (e) => {

                const input = e.querySelector(`#${MAPPING_CHECK_ID}`);

                input?.addEventListener("change", () => disabled = input.checked)

            }
        }).then(async (result) => {

            //勾選不再顯示 (按確定/取消都生效)
            if (disabled) onDisable()

            //前往綁定頁
            if (result.isConfirmed) await r.push({
                name: `Mapping`,
                params: {
                    id: id
                }
            })

        })

    }

    /**
     * 顯示swal
     * @param configure swal的設定值
     * @param type swal的類型
     */
    const build = (configure,
                   type) => {

        let resultValue = false

        const d = {
            //圖示
            icon: configure.icon ?? 'question',
            //標題
            title: sanitizeHtml(configure.subject),
            //副標題
            html: sanitizeHtml(configure.text),
            //顯示右上角關閉按鈕
            showCloseButton: false,
            //點外側關閉
            allowOutsideClick: false,
            //顯示取消按鈕
            showCancelButton: true,
            //強迫確認
            focusConfirm: false,
            //確認按鈕的預設文字
            confirmButtonText: configure.confirmButtonText ? t(configure.confirmButtonText) : t('submit.accept'),
            //取消按鈕的預設文字
            cancelButtonText: configure.cancelButtonText ? t(configure.cancelButtonText) : t('submit.cancel'),
        }

        //強迫單按鈕方式[成功]
        if (type === "success") {
            //圖示
            d.icon = "success"
            //不顯示取消按鈕
            d.showCancelButton = false
            //確認按鈕文字
            d.confirmButtonText = getOkButtonText(configure)
        }
        //強迫單按鈕方式[警示]
        else if (type === "warningOne") {
            d.icon = "warning"
            //不顯示取消按鈕
            d.showCancelButton = false
            d.confirmButtonText = getOkButtonText(configure)
        }

        //注入swal整個關閉animated後的回調
        if (configure.completion?.done) d.didClose = () => {
            if (resultValue) configure.completion.done(resultValue)
        }

        //開始前回調
        if (configure.completion?.before) configure.completion.before()

        Swal.fire(d).then((result) => {

            resultValue = result.isConfirmed

            //強迫單按鈕方式[警示]+錯誤回調
            if ( type === "warningOne" && configure.completion?.failure) configure.completion.failure()
            //詢問+成功回調
            else if (resultValue && configure.completion?.success) configure.completion.success()
            //詢問+錯誤回調
            else if (configure.completion?.failure) configure.completion.failure()

        })

    }

    /**
     * 回傳確認按鈕文字
     * @param configure
     */
    const getOkButtonText = (configure) => {
        return configure.okButtonText !== undefined ? t(configure.okButtonText) : t('submit.ok')
    }

    return {
        showSuccess,
        showWarning,
        showHandler,
        showTwoFactory,
        showErrorStatus,
        showMindCatcher,
        showDownloadSuccess,
        showMaintenance,
        showMapping
    }

}

/**
 * 自定義Swal參數
 */
;
